import { useLangStore } from '@admin/store/modules/lang'
import { useSiteStore } from '@admin/store/modules/site'
export default function useLangOptions({ props, siteCodeRef }) {
  const { sites } = useSiteStore()
  const langStore = useLangStore()
  const langOptions = computed(() => {
    if (siteCodeRef.value) {
      const targetSite = sites.find((site) => site.value === siteCodeRef.value)
      return targetSite.langs || []
    } else {
      return langStore.langOptionGroups[props.portType]
    }
  })
  return {
    langOptions,
  }
}
